import React from "react";
import { Box, CircularProgress, Grid, styled, Typography } from "@mui/material";
import { CenteredSiteBlock } from "../../routes/Home";
import SpecialCard from "../card/SpecialCard";

import logo from "../../resources/images/svg/inexplore-logo-white.svg";
import ProfileSection from "./profile/ProfileSection";
import LevelSection from "./profile/LevelSection";
import { useSelector } from "react-redux";
import { getUser } from "../../store/reducers/authSlice";
import background from "../../resources/images/svg/home/profile/background.svg";
import {useIsMobile} from "../../hooks/responsive";

const Container = styled(Box)(({ theme, backgroundImage }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    position: "relative",
    backgroundColor: theme.palette.blackPro,
    paddingTop: theme.spacing(7),
    paddingBottom: theme.spacing(7),
  };
});

const ProProfile = ({ proInfos, refetch, sectionProfileRef }) => {
  const isMobile = useIsMobile();
  const user = useSelector(getUser);

  return (
    <Container>
      <CenteredSiteBlock
        sx={{
          width: "100%",
        }}
      >
        <SpecialCard
          containerProps={{
            sx: {
              position: "relative",
              width: "100%",
              "&:hover": {
                transform: "none",
              },
            },
          }}
          sx={{
            padding: (theme) => `${theme.spacing(5)} ${theme.spacing(5)}`,
            backgroundColor: (theme) => theme.palette.blackPro,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img
            src={background}
            alt={"bg"}
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              opacity: 0.8,
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: "white",
                padding: 0,
                margin: 0,
                marginRight: 2,
              }}
            >
              Votre profil
            </Typography>
            <img
              src={logo}
              alt={"logo"}
              style={{
                marginTop: "5px",
                minHeight: "40px",
              }}
            />
          </Box>
          <Grid
            container
            sx={{
              width: "100%",
            }}
          >
            <Grid
              item
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <ProfileSection
                user={user}
                proInfo={proInfos}
                refetch={refetch}
              />
            </Grid>
            <Grid
              item
              ref={sectionProfileRef}
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <LevelSection user={user} proInfo={proInfos} />
            </Grid>
          </Grid>
        </SpecialCard>
      </CenteredSiteBlock>
    </Container>
  );
};

export default ProProfile;
